import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ArticleContent() {
    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container item xs={12} lg={10} mx="auto" direction="column">
                    {/* H1 */}
                    <MKTypography variant="h1" component="h2" mb={3} color="dark">
                        Servicii de curățenie după evenimente
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Un eveniment bun lasă amintiri frumoase. Și o sală care arată ca după un
                        dezastru. Pahare răsturnate, deșeuri împrăștiate, băi uzate, pete pe parchet
                        — toate rămân în urmă când lumea pleacă acasă. Doral Cleaning intervine
                        exact în acel moment, astfel încât tu să nu mai ai nicio grijă după ce se
                        stinge muzica.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Oferim servicii de curățenie după evenimente pentru săli, spații private și
                        locații comerciale — fie că vorbim despre o curățenie după petreceri, o
                        intervenție post eveniment sau igienizarea completă a unei săli de
                        evenimente. Echipa noastră vine organizată, cu echipamente și soluții
                        potrivite, și predă spațiul curat, proaspăt și pregătit pentru următoarea
                        utilizare.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/KcDkBFFb/Servicii-de-cur-enie-dup-evenimente.jpg"
                        alt="servicii de curățenie după evenimente pentru sală și spații comerciale"
                        sx={{
                            maxWidth: "100%",
                            width: { xs: "100%", md: "600px" },
                            display: "block",
                            margin: "0 auto",
                        }}
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H2 */}
                    <MKTypography variant="h2" mb={3} color="dark">
                        Ce presupune serviciul de curățenie după evenimente
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={4}>
                        Curățenia după evenimente înseamnă mai mult decât strângerea paharelor. După
                        o nuntă, o conferință, un botez sau un eveniment corporate rămân în urmă
                        suprafețe lipicioase, urme de trafic intens, băi solicitate la maximum și
                        zone care nu pot fi repuse în circuit cu o mătură și un mop. Intervenția
                        noastră acoperă tot ce rămâne vizibil și invizibil după ce ultimul invitat a
                        plecat — astfel încât la final spațiul să arate ca înainte de eveniment, nu
                        după.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Colectarea deșeurilor și eliberarea rapidă a spațiului
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Primul pas este strângerea rapidă a tot ce rămâne: pahare, ambalaje,
                        decorațiuni, resturi alimentare, materiale promoționale. Eliberăm spațiul
                        metodic, fără haos, pentru că în multe cazuri sala trebuie predată sau
                        pregătită pentru următoarea activitate în cel mai scurt timp posibil.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Igienizarea suprafețelor, băilor și zonelor intens folosite
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Mesele, blaturile, mânerele și zonele de servire acumulează bacterii și
                        murdărie invizibilă după ore întregi de utilizare intensă. Grupurile
                        sanitare sunt curățate și dezinfectate complet, nu doar superficial. Acordăm
                        atenție specială punctelor de contact frecvent, acolo unde igiena contează
                        cel mai mult.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Curățarea pardoselilor și a urmelor dificile
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Pardoselile sunt printre cele mai afectate suprafețe după un eveniment: urme
                        de trafic, pete de băuturi, noroi adus din exterior, zone lipicioase sau
                        depuneri persistente. Intervenim în funcție de tipul suprafeței — parchet,
                        gresie, marmură, linoleum — cu echipamente și soluții potrivite fiecărui
                        material. Pentru situații care necesită o intervenție mai amplă, este
                        disponibil și serviciul de{" "}
                        <a
                            href="https://doral-cleaning.ro/curatare-pardoseli"
                            style={{ color: "#1a73e8", textDecoration: "underline" }}
                        >
                            curățare de pardoseli
                        </a>
                        .
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={4}>
                        Serviciul nu se limitează la sălile de nunți. Intervenim în orice tip de
                        locație unde un eveniment a lăsat urme — de la spații private la
                        restaurante, birouri, showroom-uri și locații comerciale. Fiecare spațiu are
                        propriile priorități: un restaurant trebuie repus în funcțiune rapid, o sală
                        de evenimente trebuie predată proprietarului în stare bună, un spațiu
                        corporate nu poate rămâne blocat. Ne adaptăm la fiecare situație în parte.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/zWqp5ybG/Unde-intervenim-dup-evenimente.jpg"
                        alt="curățenie evenimente pentru săli private spații comerciale și locații corporate"
                        sx={{
                            maxWidth: "100%",
                            width: { xs: "100%", md: "600px" },
                            display: "block",
                            margin: "0 auto",
                        }}
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Curățenie după petreceri private, nunți și aniversări
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Petrecerile private — nunți, aniversări, botezuri, majoraturi — lasă în urmă
                        pahare, resturi alimentare, pete accidentale și băi foarte solicitate.
                        Curățenia de după eveniment îi scutește pe organizatori de cea mai
                        obositoare parte a serii și aduce spațiul la o stare bună fără efort
                        suplimentar din partea lor.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Curățenie dupa conferințe, târguri și evenimente corporate
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Conferințele, târgurile și evenimentele corporate generează alte tipuri de
                        dezordine: materiale promoționale abandonate, zone de acces intens
                        circulate, mese și echipamente folosite ore în șir. Spațiul trebuie pregătit
                        rapid pentru programul obișnuit, fără întârzieri care să afecteze
                        activitatea.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Curățenie pentru săli de evenimente, restaurante și spații comerciale
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Sălile de evenimente, restaurantele și spațiile comerciale au suprafețe și
                        solicitări diferite după fiecare eveniment. Uneori este suficientă o
                        intervenție generală; alteori pardoselile, băile, geamurile sau zonele de
                        intrare au nevoie de atenție suplimentară. Evaluăm fiecare situație separat
                        și intervenim proporțional cu gradul de murdărie.
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={4}>
                        Orice firmă de curățenie îți promite că vine repede și face treabă bună. Noi
                        mergem mai departe: echipa noastră intră organizat, cu o ordine clară de
                        intervenție, și nu pleacă până când spațiul nu trece de o verificare finală.
                        Dacă la final există o zonă care nu corespunde așteptărilor, revenim. Fără
                        discuții suplimentare.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/hRQmXYf9/Motive-alegere-Doral-Cleaning.jpg"
                        alt="de ce să alegi firmă curățenie evenimente Doral Cleaning"
                        sx={{
                            maxWidth: "100%",
                            width: { xs: "100%", md: "600px" },
                            display: "block",
                            margin: "0 auto",
                        }}
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Intervenție rapidă și organizare eficientă a echipei
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Știm că după un eveniment timpul contează. Sala trebuie predată,
                        restaurantul trebuie redeschis, spațiul comercial nu poate sta blocat. De
                        aceea echipa intră pregătită, cu o repartizare clară a sarcinilor, și
                        acoperă etapele importante fără pierderi de timp. Programarea se face în
                        avans, iar în situații urgente găsim soluții.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Echipamente profesionale și soluții potrivite fiecărei suprafețe
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Parchetul se curăță altfel decât gresia. Marmura nu suportă aceleași produse
                        ca betonul șlefuit. Folosim echipamente și soluții specifice fiecărui tip de
                        suprafață, astfel că intervenția este eficientă fără riscul de a afecta
                        finisajele sau aspectul materialelor.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Servicii adaptate în funcție de spațiu și gradul de murdărie
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        O aniversare de 20 de persoane nu lasă aceleași urme ca un eveniment
                        corporate cu sute de participanți. Nu aplicăm același tip de intervenție
                        indiferent de situație. Stabilim de la început ce zone necesită atenție
                        sporită, ce suprafețe au nevoie de tratament special și cum poate fi
                        organizată echipa pentru cel mai bun rezultat în timpul disponibil.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Experiență în evenimente majore
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Am oferit servicii de curățenie la evenimente importante precum IRB Nations
                        Cup, EXPO Make-Up, precum și concertele artiștilor Sting și Cesaria Evora.
                    </MKTypography>

                    {/* H2 */}
                    <MKTypography variant="h2" mb={3} color="dark">
                        Evaluarea spațiului și stabilirea necesarului de intervenție
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Procesul este simplu și nu îți ia mult timp. Ai nevoie să ne spui câteva
                        detalii, iar noi ne ocupăm de restul.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Înainte de intervenție stabilim împreună detaliile care contează: tipul
                        spațiului, suprafața totală, ce fel de eveniment a avut loc, în ce stare a
                        rămas locația și în ce interval trebuie finalizată curățenia. Aceste
                        informații ne permit să facem o estimare realistă și să organizăm echipa
                        corect de la început. Contează dacă este vorba despre o sală de evenimente,
                        un restaurant, un showroom sau un birou — fiecare are priorități diferite și
                        zone care necesită atenție specifică.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Intervenția propriu-zisă și verificarea finală
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Odată stabilit planul, echipa intră în lucru în ordinea logică: mai întâi
                        colectarea deșeurilor, apoi curățarea suprafețelor, igienizarea băilor,
                        curățarea pardoselilor și atenția acordată zonelor cele mai solicitate. Dacă
                        situația o cere, pot fi incluse și intervenții suplimentare, inclusiv{" "}
                        <a
                            href="https://doral-cleaning.ro/curatare-geamuri-suprafete-vitrate"
                            style={{ color: "#1a73e8", textDecoration: "underline" }}
                        >
                            curățare geamuri și suprafețe vitrate
                        </a>
                        . La final, spațiul este verificat înainte de predare, astfel încât totul să
                        fie în ordine și gata de utilizare.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/3YMJjd7y/Servicii-complementare-Doral-Cleaning.jpg"
                        alt="servicii complementare după curățenie evenimente pentru spații impecabile"
                        sx={{
                            maxWidth: "100%",
                            width: { xs: "100%", md: "600px" },
                            display: "block",
                            margin: "0 auto",
                        }}
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    <MKTypography variant="body1" color="text" mb={2}>
                        Curățenia de după un eveniment rezolvă problema imediată. Dar dacă locația
                        este folosită frecvent sau găzduiește evenimente repetate, murdăria se
                        acumulează mai repede între intervenții. Serviciile complementare ajută la
                        menținerea unui standard constant, nu doar la rezolvarea punctuală a
                        dezordinii.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Dacă locația găzduiește frecvent petreceri, conferințe sau alte evenimente,
                        un plan de{" "}
                        <a
                            href="https://doral-cleaning.ro/curatenie-de-intretinere"
                            style={{ color: "#1a73e8", textDecoration: "underline" }}
                        >
                            curățenie de întreținere
                        </a>{" "}
                        ajută la păstrarea ordinii de la o intervenție la alta. Murdăria se
                        acumulează mai greu, iar spațiul rămâne prezentabil între evenimente — fără
                        efort suplimentar din partea ta.
                    </MKTypography>

                    {/* H2 */}
                    <MKTypography variant="h2" mb={3} color="dark">
                        Solicită acum o ofertă pentru curățenie după evenimente
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={6}>
                        Dacă ai nevoie de curățenie după petreceri, nunți, botezuri, aniversări,
                        conferințe sau orice alt tip de eveniment, Doral Cleaning poate interveni
                        rapid, indiferent de tipul spațiului sau de starea în care a rămas locația.
                        Pentru a face o estimare corectă, avem nevoie să știm câteva lucruri: ce
                        suprafață trebuie curățată, ce tip de eveniment a avut loc și în ce interval
                        trebuie realizată intervenția. Pe baza acestor detalii îți trimitem o ofertă
                        clară, fără surprize.
                    </MKTypography>

                    {/* H2 */}
                    <MKTypography variant="h2" mb={4} color="dark">
                        Întrebări frecvente
                    </MKTypography>

                    <MKBox component="ul" pl={4} mb={4}>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>Cât de repede puteți interveni după un eveniment?</strong>
                            <br />
                            Depinde de programare, locație și volumul de lucru. În cele mai multe
                            cazuri, echipa poate fi organizată rapid — chiar și în aceeași zi sau a
                            doua zi după eveniment. Cu cât ne contactezi mai devreme, cu atât
                            planificarea este mai simplă și intervenția mai rapidă.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>
                                Serviciul este disponibil doar pentru săli de evenimente?
                            </strong>
                            <br />
                            Nu. Intervenim în orice tip de locație: spații private, restaurante,
                            birouri, locații comerciale, showroom-uri sau spații folosite pentru
                            evenimente corporate. Dacă evenimentul a avut loc acolo, putem curăța.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>Puteți face curățenie și înainte de eveniment?</strong>
                            <br />
                            Da. Oferim și curățenie înainte de eveniment, pentru ca spațiul să fie
                            pregătit corespunzător înainte de sosirea invitaților. Acest serviciu se
                            stabilește separat, în funcție de tipul locației și de nevoile
                            specifice. Contactează-ne pentru detalii.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>
                                Ce faceți dacă există pete dificile sau murdărie persistentă?
                            </strong>
                            <br />
                            Folosim soluții și echipamente specifice tipului de suprafață și naturii
                            murdăriei. Pentru situații mai complexe — pete adânci, suprafețe
                            degradate, zone cu depuneri persistente — putem recomanda servicii
                            suplimentare adaptate, care rezolvă problema temeinic, nu superficial.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>
                                Cum se stabilește prețul pentru curățenia după evenimente?
                            </strong>
                            <br />
                            Prețul depinde de suprafață, tipul locației, gradul de murdărie,
                            intervalul disponibil pentru intervenție și eventualele servicii
                            suplimentare. Trimite-ne detaliile și primești o ofertă clară, fără
                            costuri ascunse.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>
                                Trebuie să asigur eu produsele sau echipamentele de curățenie?
                            </strong>
                            <br />
                            Nu. Echipa vine cu tot ce este necesar: produse profesionale,
                            echipamente și materiale consumabile. Nu ai nicio obligație suplimentară
                            din partea ta. Detaliile exacte se stabilesc la momentul solicitării
                            ofertei.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>Ce include, de regulă, curățenia după un eveniment?</strong>
                            <br />
                            Serviciul acoperă colectarea deșeurilor, igienizarea suprafețelor și a
                            punctelor de contact, curățarea grupurilor sanitare, curățarea
                            pardoselilor și intervenția în zonele cele mai solicitate. La nevoie,
                            pot fi adăugate și servicii suplimentare pentru anumite suprafețe sau
                            finisaje.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>
                                Serviciul este potrivit și pentru evenimente corporate sau spații
                                comerciale?
                            </strong>
                            <br />
                            Da. Intervenim atât după evenimente private, cât și după conferințe,
                            târguri, lansări de produse, evenimente în showroom-uri, restaurante sau
                            orice alt tip de spațiu comercial. Serviciul se adaptează la specificul
                            și cerințele fiecărei locații.
                        </MKTypography>
                    </MKBox>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
